import { render, staticRenderFns } from "./RegionPager.vue?vue&type=template&id=7e6ef979&"
import script from "./RegionPager.vue?vue&type=script&lang=js&"
export * from "./RegionPager.vue?vue&type=script&lang=js&"
import style0 from "./RegionPager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports